import nanoajax from 'nanoajax'
import {
  objectToUrlParams,
  ajaxRequest
} from 'utils/general'

const BASE_URL = 'https://api.yotpo.com/v1'

class Yotpo {
  constructor () {
    this.domain = `https://${__GLOBAL__.domain}/`
    this.key = __GLOBAL__.yotpoKey
  }

  postReview (payload) {
    return new Promise((resolve, reject) => {
      payload.appkey = this.key
      payload.domain = this.domain
      const postData = JSON.parse(JSON.stringify(payload))
      nanoajax
        .ajax({
          url: `${BASE_URL}/widget/reviews`,
          method: 'post',
          body: objectToUrlParams(postData)
        }, (code, responseText, request) => {
          resolve({ code, responseText, request })
        })
    })
  }

  voteReview (payload) {
    return new Promise((resolve, reject) => {
      nanoajax
        .ajax({
          url: `${BASE_URL}/reviews/${payload.reviewId}/vote/${payload.voteType}`,
          method: 'post'
        }, (code, response, request) => {
          resolve(response)
        })
    })
  }

  undoVoteReview (payload) {
    return new Promise((resolve, reject) => {
      nanoajax
        .ajax({
          url: `${BASE_URL}/reviews/${payload.reviewId}/vote/${payload.voteType}/true`,
          method: 'post'
        }, (code, response, request) => {
          resolve(response)
        })
    })
  }

  /**
   * @param {string} albumName Name of the album as string. eg: "My Posts Album"
   * @returns A paginated result including both photos and videos from the album
   */
  getMediaByAlbum (albumName, page = 1, perPage = 20) {
    // https://api.yotpo.com/v1/widget/<yotpo_key>/albums/by_name?page=1&album_name=<album_name>
    const encodedAlbumName = encodeURIComponent(albumName)
    if (encodedAlbumName) {
      return ajaxRequest(`${BASE_URL}/widget/${this.key}/albums/by_name?page=${page}&per_page=${perPage}&album_name=${encodedAlbumName}`)
    }
  }
}

export default new Yotpo()
